import React from 'react';

import useTrackingEvent from '@hpstellar/core/hooks/useTrackingEvent';
import withPageComponents from '../../../page/components/with-page-components';


import {getProductClickMetrics} from '../../../metrics/metrics-helpers';

const PDP_METRICS = [
    // "See complete specs" button
    {
        action: 'see-more',
        component: 'pdp/TechSpecs',
        metrics: {
            eventName: 'linkClick',
            params: {
                event: 'e_linkClick',
                linkPlacement: 'product',
                linkId: 'see-complete-specs'
            }
        }
    },
    // "See more features" button
    {
        component: 'pdp/Features',
        action: 'see-more',
        metrics: {
            eventName: 'linkClick',
            params: {
                event: 'e_linkClick',
                linkPlacement: 'product',
                linkId: 'see-more-features'
            }
        }
    },
    // "Learn more" Recommended Accessories button
    {
        component: 'pdp/RecommendedAccessories',
        action: 'see-product-via-label',
        metrics: {
            eventName: 'productClick',
            getParams: (event, params) => {
                try{
                    let { relatedProducts } = params.pdpCrossSell;
                    let {id} = event;
                    let product = relatedProducts.find( relatedPrd => relatedPrd && relatedPrd.sku === id);

                    // TODO: Should we add position? That will require adding another <TrackingPDPMetrics /> in the PDPCrossSell
                    // since the position is dynamically determined.
                    let metricParams = getProductClickMetrics({ product, list: 'pdp-accessories'});

                    return {
                        eventName: 'productClick',
                        params: metricParams
                    };
                }catch(e){}
            }
        }
    }
]


const TrackingPDPMetrics = ({ trackCustomMetric, ...rest }) => {
    useTrackingEvent(e => {
        let { action, component } = e || {};
        for(let metric of PDP_METRICS){
            if(metric && metric.action === action && metric.component === component && metric.metrics){
                let {eventName, params, getParams} = metric.metrics;
                trackCustomMetric(
                    eventName, 
                    typeof getParams === 'function' ? getParams(e, rest) : params
                );
            }
        }
    });
    return null;
}

export default withPageComponents(TrackingPDPMetrics, { components: ['pdpCrossSell'] });